<template>
  <router-link class="link" :to="{ name: 'user.author.profile', params: {id: user.id} }">
    <div class="author">
      <picture class="author__image embed-responsive embed-responsive-1by1">
        <img
          class="embed-responsive-item"
          :src="user.avatar"
          :alt="user.name"
        />
      </picture>

      <span class="author__legend">SEU PROFESSOR</span>
      <span class="author__name">{{ user.name }}</span>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      user: { type: Object, default: () => ({}) }
    }
  }
</script>

<style scoped lang="scss">
  .author {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    height: 60px;

    &__image {
      flex: 0 0 100%;
      width: 60px;
      border-radius: 100%;
      margin-right: 10px;
    }

    &__legend,
    &__name {
      width: calc(100% - 70px);
    }

    &__legend {
      font-size: 12px;
      font-weight: 300;
      color: lighten(#000, 40%);
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
      color: #000;
    }

    &:hover &__name {
      color: #ff8000;
    }
  }
</style>